module.exports = __webpack_public_path__ + "static/media/battery-empty.9e85d6b8.svg";